<section class="risk-summary" [ngClass]="getStateClass()" *ngIf="isVisible()">
	<div class="risk-summary-main">
		<div class="risk-summary-icon" aria-hidden="true">
			<i [ngClass]="getStateIconClass()"></i>
		</div>

		<div class="risk-summary-content">
			<h3>{{ getStateTitle() }}</h3>

			<p class="risk-summary-message" *ngIf="getPrimaryMessage()">
				<span>{{ getPrimaryMessage() }}</span>

				<button
					*ngIf="isRiskState() && hasDetails()"
					type="button"
					class="risk-details-toggle"
					(click)="toggleDetails()"
					[attr.aria-expanded]="isDetailsExpanded"
					aria-controls="report-risk-detail-items"
				>
               <span>
                  {{ isDetailsExpanded ? 'Hide details' : 'View details' }}
               </span>

					<i
						class="pi"
						[ngClass]="
                     isDetailsExpanded ? 'pi-chevron-up' : 'pi-chevron-down'
                  "
						aria-hidden="true"
					></i>
				</button>
			</p>
		</div>
	</div>

	<div
		id="report-risk-detail-items"
		class="risk-details-expanded"
		*ngIf="isRiskState() && hasDetails() && isDetailsExpanded"
	>
		<p class="risk-expanded-summary" *ngIf="getExpandedSummary()">
			{{ getExpandedSummary() }}
		</p>

		<div class="risk-detail-items">
			<article
				class="risk-detail-item"
				*ngFor="
               let item of getItems();
               let i = index;
               trackBy: trackByRiskItem
            "
			>
				<div class="risk-detail-header">
					<div class="risk-detail-title-area">
						<h4>{{ getItemTitle(item) }}</h4>

						<div class="risk-code" *ngIf="item.RiskCode">
							{{ item.RiskCode }}
						</div>
					</div>

					<div class="risk-detail-badges">
                  <span
										class="severity-badge"
										*ngIf="item.Severity"
										[ngClass]="getSeverityClass(item.Severity)"
									>
                     {{ item.Severity }}
                  </span>

						<span class="category-badge" *ngIf="item.Category">
                     {{ item.Category }}
                  </span>
					</div>
				</div>

				<div
					class="risk-detail-statistics"
					*ngIf="
                  hasItemNumber(item.Count) ||
                  hasItemNumber(item.FindingCount) ||
                  hasItemNumber(item.RiskValue)
               "
				>
					<div class="risk-detail-stat" *ngIf="hasItemNumber(item.Count)">
						<span class="label">Count</span>
						<span class="value">{{ item.Count }}</span>
					</div>

					<div
						class="risk-detail-stat"
						*ngIf="hasItemNumber(item.FindingCount)"
					>
						<span class="label">Findings</span>
						<span class="value">{{ item.FindingCount }}</span>
					</div>

					<div
						class="risk-detail-stat"
						*ngIf="hasItemNumber(item.RiskValue)"
					>
						<span class="label">Risk Value</span>
						<span class="value">
                     {{ formatRiskValue(item.RiskValue) }}
                  </span>
					</div>
				</div>

				<p class="risk-detail-summary" *ngIf="item.Summary">
					{{ item.Summary }}
				</p>

				<div class="risk-detail-action" *ngIf="item.RecommendedAction">
					<span class="label">Recommended action:</span>

					<span class="value">
                  {{ item.RecommendedAction }}
               </span>
				</div>
			</article>
		</div>
	</div>
</section>
